import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const generatedBlogsListStyles: Record<string, SxProps<Theme>> = {
  section: {
    scrollMarginTop: 24,
  },
  card: {
    p: 2.5,
    borderRadius: 2,
    border: (t) => `1px solid ${alpha(t.palette.divider, 0.12)}`,
    bgcolor: "background.paper",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: (t) =>
        `0 4px 20px ${alpha(t.palette.common.black, 0.08)}`,
    },
  },
  statusChip: {
    fontWeight: 600,
    fontSize: "0.75rem",
  },
  empty: {
    py: 8,
    textAlign: "center",
    color: "text.secondary",
  },
};

export default generatedBlogsListStyles;
